import { connect } from 'react-redux'

import AppBar from '../components/AppBar'
import { pushLocation } from '../../../store/location'
import { toggleProfile, toggleMenu, doGoBack } from '../../../store/global'

const mapStateToProps = state => ({ ...state.authentication, ...state.global })

const mapDispatchToProps = (dispatch, ownProps) => ({
  onGoHome() {
    dispatch(pushLocation('/'))
    if (!ownProps.drawerDocked) {
      dispatch(toggleMenu(false))
      dispatch(toggleProfile(false))
    }
  },
  doGoBackButton() {
    dispatch(doGoBack())
  }
})

const AppBarContainer = connect(mapStateToProps, mapDispatchToProps)(AppBar)

export default AppBarContainer



// WEBPACK FOOTER //
// ./src/layouts/Authenticated/containers/AppBar.js